import React, { forwardRef } from 'react';
import classNames from 'classnames';
import DOMPurify from 'dompurify';

const HtmlContent = forwardRef(({ content = '', className = '' }, ref) => {
  const clean = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      'a',
      'b',
      'blockquote',
      'br',
      'del',
      'div',
      'em',
      'figcaption',
      'figure',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'hr',
      'i',
      'img',
      'li',
      'mark',
      'ol',
      'p',
      'section',
      'span',
      'strong',
      'sub',
      'sup',
      'table',
      'tbody',
      'th',
      'tr',
      'td',
      'u',
      'ul',
      'iframe',
    ],
    ALLOWED_ATTR: [
      'style',
      'href',
      'rel',
      'src',
      'align',
      'alt',
      'width',
      'height',
      'class',
      'colspan',
      'rowspan',
      'id',
      'target',
      'title',
      'frameborder',
      'allow',
      'referrerpolicy',
      'allowfullscreen',
    ],
  });

  const classes = classNames({
    [className]: Boolean(className),
  });

  return (
    <div
      ref={ref}
      className={classes}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
});

export default HtmlContent;
